import React from 'react';
import translate from '@/lib/intl/translate';

export default function LockedSalesforceHelperText({
  locked,
}: {
  locked: boolean;
}) {
  if (!locked) {
    return null;
  }

  return (
    <span className="text-[10px] text-text-secondary/40">
      {translate('INTEGRATIONS_SALESFORCE')}
    </span>
  );
}
